(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('CutOffController', CutOffController);

    CutOffController.$inject = ['$scope', '$state', 'DataUtils', 'CutOff','NgTableParams'];

    function CutOffController ($scope, $state, DataUtils, CutOff,NgTableParams) {
        var vm = this;
//        vm.cutOff = [{cutOffDate:'02-02-2016',description:'Thời gian kết sổ tự động => ngày 28 hàng tháng: lúc 11:00 tối',createdDate:'01-10-2016',status:'1'},
//                     {cutOffDate:'01-01-2017',description:'Thời gian kết sổ tự động => ngày 28 hàng tháng: lúc 11:00 tối',createdDate:'01-10-2016',status:'1'}];
        vm.cutOff = [];
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;

        loadAll();

        function loadAll() {
        	CutOff.query(function(result) {
                vm.cutoff = result;
                if(vm.cutoff !=null && vm.cutoff.length > 0){
                	var i;
                	for( i = 0; i < vm.cutoff.length; i++){
                		if(vm.cutoff[i].status == 1){
                			vm.cutoff[i].statusName = true;
                		}else{
                			vm.cutoff[i].statusName = false;
                		}
                	}
                	vm.tableParams = new NgTableParams({
    					page : 1, // show first page
    					count : 5
    				// count per page
    				}, {
    					filterDelay : 0,
    					dataset : vm.cutoff
    				});
                }
            });
        }
    }
})();
